/** Control, then Variant A, B, ... unless the user named the variant. PHP twin: `AudienceTest::versionLabel()`. */
export function versionLabel(
  test: { readonly versions: readonly { readonly id: string; readonly name: string }[] } | undefined,
  versionId: string
): string {
  if (versionId === 'A') {
    return 'Control'
  }
  const versions = test?.versions ?? []
  const index = versions.findIndex((item) => item.id === versionId)
  const name = versions[index]?.name ?? ''
  return name && !/^(Version )?[A-D]$/.test(name) ? name : `Variant ${String.fromCharCode(64 + Math.max(index, 1))}`
}
